/**
 * Static NSE symbol → cap bucket for portfolio mix (heuristic, extend over time).
 * Unknown symbols roll into "unclassified" in KPI math — not investment advice.
 */
export type CapTier = 'LARGE' | 'MID' | 'SMALL' | 'UNKNOWN';

const LARGE = new Set(
  (
    'RELIANCE,TCS,HDFCBANK,INFY,ICICIBANK,HINDUNILVR,SBIN,BHARTIARTL,ITC,KOTAKBANK,LT,HCLTECH,AXISBANK,ASIANPAINT,MARUTI,TITAN,SUNPHARMA,ULTRACEMCO,NESTLEIND,WIPRO,ONGC,NTPC,POWERGRID,M&M,TATAMOTORS,TATASTEEL,JSWSTEEL,ADANIENT,ADANIPORTS,HINDALCO,DIVISLAB,DRREDDY,CIPLA,BPCL,EICHERMOT,GRASIM,SBILIFE,TECHM,INDUSINDBK,APOLLOHOSP,COALINDIA,BRITANNIA,HEROMOTOCO,UPL,VEDL,BAJFINANCE,BAJAJFINSV,DMART,PIDILITIND,HAVELLS,BANDHANBNK,FEDERALBNK,MUTHOOTFIN,CHOLAFIN,SAIL,BERGEPAINT,MARICO,SIEMENS,GODREJC,PAGEIND,DABUR,TATACONSUM,HDFCLIFE,ICICIGI,ICICIPRULI,NYKAA,ZOMATO,PAYTM,PERSISTENT,LTIM,COLPAL,TORNTPHARM,ALKEM,BIOCON,ABB,SHREECEM,TRENT,INDIGO,BAJAJHLDNG,IRCTC,GAIL,ADANIGREEN,ADANITRANS,LODHA,MAXHEALTH,POLYCAB,TVSMOTOR,ASHOKLEY,PIDILITIND'
  )
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
);

const MID = new Set(
  (
    'AUROPHARMA,BALKRISIND,BATAINDIA,BHEL,CANBK,CHAMBLFERT,CUMMINSIND,DIXON,EXIDEIND,GLENMARK,GODREJIND,HINDPETRO,IDFCFIRSTB,IEX,IRFC,JINDALSTEL,LICHSGFIN,M&MFIN,MANKIND,MPHASIS,NMDC,OBEROI,OFSS,PATANJALI,PFC,PHOENIXLTD,PIIND,PNB,RBLBANK,RECLTD,SCHAEFFLER,SOLARINDS,SUPREMEIND,TATAELXSI,TATAPOWER,THERMAX,TORNTPOWER,UBL,UNIONBANK,VOLTAS,ZYDUSLIFE,APLAPOLLO,CONCOR,DEEPAKNTR,ESCORTS,GUJGASLTD,HDFCAMC,IIFL,JUBLFOOD,LALPATHLAB,LUPIN,MRF,NATIONALUM,NAVINFLUOR,PAGEIND,PEL,STAR,SYNGENE,TATACHEM,ABCAPITAL,ABFRL,ADANIPOWER,AMBUJACEM,BANKBARODA,BHARATFORG,BOSCHLTD,CHOLAHLDNG,CROMPTON,DALBHARAT,DIVISLAB,GLAXO,GNFC,GODREJPROP,HDFCLIFE,HINDCOPPER,INDHOTEL,INDUSTOWER,IPCALAB,JSL,JUBLINGREA,KPITTECH,L&TFH,LICHSGFIN,LTTS,MARUTI,MINDTREE,MOTHERSON,NAM-IND,NHPC,OIL,PAGEIND,PETRONET,PIRAMALFIN,RAMCOCEM,SAIL,SRF,SUNTV,TORNTPHARM,UBL,VBL,VOLTAS,WHIRLPOOL'
  )
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
);

const SMALL = new Set(
  (
    'IDEA,SUZLON,YESBANK,GMRINF,PNBHOUSING,IOB,UCOBANK,BANKINDIA,CENTRALBK,MAHABANK,J&KBANK,RATNAMANI,TRIDENT,IRB,RVNL,RAILTEL,NBCC,SJVN,IREDA,IRCON,NH,NLCINDIA,BDL,BEL,HAL,COCHINSHIP,MAZDOCK,GRSE,SCI,GSPL,ATGL,MGL,ADANIGREEN'
  )
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
);

export function getNseCapTier(stockCode: string): CapTier {
  const s = stockCode.trim().toUpperCase();
  if (!s) return 'UNKNOWN';
  if (LARGE.has(s)) return 'LARGE';
  if (MID.has(s)) return 'MID';
  if (SMALL.has(s)) return 'SMALL';
  return 'UNKNOWN';
}
